import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/section-renewal/SectionRenewalAction";
import { redirectToPages } from "../../../../../_helpers/Helpers";
import { TermAndSectionCard } from "./TermAndSectionCard";
import { StudentsPage } from "./students/StudentsPage";

export function SectionRenewalPage() {
  const [currentTerm, setCurrentTerm] = useState(0);
  const [currentSectionId, setCurrentSectionId] = useState();
  const [newTerm, setNewTerm] = useState(0);
  const [newSectionId, setNewSectionId] = useState();
  
  // Getting curret state of Section Renewal from store (Redux)
  const dispatch = useDispatch();
  const { currentActiveTerm, isSuccess, type, sections } = useSelector(
    (state) => ({
      isSuccess: state.sectionRenewal.isSuccess,
      type: state.sectionRenewal.type,
      currentActiveTerm: state.auth.user.currentActiveTerm,
      sections: state.sectionRenewal.sections,
    }),
    shallowEqual
  );
  
  useEffect(() => {
    setCurrentTerm(currentActiveTerm);
    setNewTerm(currentActiveTerm + 1);
    dispatch(actions.getSections());
    return () => dispatch(actions.cleanSectionRenewalState());
  }, [currentActiveTerm, dispatch]);  
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <TermAndSectionCard
            title="Şimdiki Dönem Şube"
            term={currentTerm}            
            sections={sections}
            setTerm={setCurrentTerm}
            setSectionId={setCurrentSectionId}
          />
        </div>
        <div className="col-6">
          <TermAndSectionCard
            title="Yeni Dönem Şube"
            term={newTerm}
            sections={sections}
            setTerm={setNewTerm}
            setSectionId={setNewSectionId}
          />
        </div>
      </div>
      <StudentsPage
        currentTerm={currentTerm}
        currentSectionId={currentSectionId}
        newTerm={newTerm}
        newSectionId={newSectionId}
      />
    </>
  );
}